import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  const [selectedPack, setSelectedPack] = useState<1 | 2>(2);
  const handleCtaClick = () => {
    if (selectedPack === 1) {
      // URL de pago Megapack 1
      window.location.href = '#pago-megapack-1';
    } else {
      // URL de pago Megapack Completo
      window.location.href = '#pago-megapack-completo';
    }
  };
  return <section id="pricing" className="bg-[#0A1628] py-12 px-6" data-id="element-259">
      <div className="max-w-3xl mx-auto" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-261">
          <h2 className="font-display font-bold text-[32px] md:text-[42px]" data-id="element-262">
            <span className="text-[#FFFFFF]" data-id="element-263">ELIGE TU</span>{' '}
            <span className="text-[#C9A84C]" data-id="element-264">MEGAPACK</span>
          </h2>
        </motion.div>

        <div className="flex flex-col gap-[8px]" data-id="element-265">
          {/* TARJETA OPCIÓN 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelectedPack(1)} className={`relative p-[16px] rounded-[16px] cursor-pointer transition-all duration-300 flex items-center gap-4 md:gap-6 w-full ${selectedPack === 1 ? 'bg-[#0F1E35] border-2 border-[#C9A84C] shadow-[0_0_20px_rgba(201,168,76,0.25)]' : 'bg-[#0F1E35] border-[1.5px] border-[#2A3A50] shadow-none'}`} data-id="element-266">
            {/* Círculo de selección */}
            <div className={`w-[24px] h-[24px] rounded-full flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 1 ? 'border-2 border-[#C9A84C] bg-[#C9A84C]' : 'border-2 border-[#AAAAAA] bg-transparent'}`} data-id="element-267">
              {selectedPack === 1 && <div className="w-[10px] h-[10px] rounded-full bg-[#0A1628]" data-id="element-268" />}
            </div>

            {/* Contenido de la tarjeta */}
            <div className="flex-grow flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-269">
              <div data-id="element-270">
                <h3 className="text-[#FFFFFF] text-[22px] font-bold leading-tight mb-0.5 flex items-center gap-2" data-id="element-271">
                  <span className="text-[28px] leading-none" data-id="element-272">📘</span> MEGAPACK
                  1
                </h3>
                <p className="text-[#FFFFFF] text-[18px] font-bold leading-tight mb-1" data-id="element-273">
                  TDAH: GUÍA PARA SALVAR A TU HIJO
                </p>
                <p className="text-[#AAAAAA] text-[15px] font-normal mb-1.5" data-id="element-274">
                  5 Tomos + 3 Bonos
                </p>
                <p className="text-[#C9A84C] text-[14px] font-bold" data-id="element-275">
                  Ideal para: Recuperar la calma en casa desde esta semana
                </p>
              </div>

              <div className="flex flex-col items-start md:items-end mt-2 md:mt-0" data-id="element-276">
                <span className="text-[#666666] text-[16px] line-through mb-0.5" data-id="element-277">
                  75,76€
                </span>
                <div className="flex items-baseline" data-id="element-278">
                  <span className="text-[#FFFFFF] text-[28px] md:text-[36px] font-extrabold leading-none" data-id="element-279">
                    14,97
                  </span>
                  <span className="text-[#FFFFFF] text-[22px] font-bold ml-1" data-id="element-280">
                    €
                  </span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* TARJETA OPCIÓN 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelectedPack(2)} className={`relative p-[16px] rounded-[16px] cursor-pointer transition-all duration-300 flex items-center gap-4 md:gap-6 w-full mt-2 md:mt-0 ${selectedPack === 2 ? 'bg-[#0F1E35] border-2 border-[#C9A84C] shadow-[0_0_20px_rgba(201,168,76,0.25)]' : 'bg-[#0F1E35] border-[1.5px] border-[#2A3A50] shadow-none'}`} data-id="element-281">
            {/* Badge */}
            <div className="absolute -top-3 right-4 md:right-6 bg-[#C9A84C] text-[#0A1628] font-bold text-[12px] px-[12px] py-[4px] rounded-[20px] font-body" data-id="element-282">
              ⭐ MÁS ELEGIDO
            </div>

            {/* Círculo de selección */}
            <div className={`w-[24px] h-[24px] rounded-full flex-shrink-0 flex items-center justify-center transition-colors ${selectedPack === 2 ? 'border-2 border-[#C9A84C] bg-[#C9A84C]' : 'border-2 border-[#AAAAAA] bg-transparent'}`} data-id="element-283">
              {selectedPack === 2 && <div className="w-[10px] h-[10px] rounded-full bg-[#0A1628]" data-id="element-284" />}
            </div>

            {/* Contenido de la tarjeta */}
            <div className="flex-grow flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-285">
              <div data-id="element-286">
                <h3 className="text-[#FFFFFF] text-[22px] font-bold leading-tight mb-0.5 flex items-center gap-2" data-id="element-287">
                  <span className="text-[28px] leading-none" data-id="element-288">🏆</span> MEGAPACK
                  COMPLETO
                </h3>
                <p className="text-[#FFFFFF] text-[18px] font-bold leading-tight mb-1" data-id="element-289">
                  TDAH: GUÍA PARA SALVAR A TU HIJO
                  <br className="hidden md:block" data-id="element-290" />+ EL CAMINO AL ÉXITO
                </p>
                <p className="text-[#AAAAAA] text-[15px] font-normal mb-1.5" data-id="element-291">
                  10 Tomos + 7 Bonos
                </p>
                <p className="text-[#C9A84C] text-[14px] font-bold" data-id="element-292">
                  Ideal para: Resolver el presente Y asegurar
                  <br className="hidden md:block" data-id="element-293" />
                  el futuro de tu hijo
                </p>
              </div>

              <div className="flex flex-col items-start md:items-end mt-2 md:mt-0" data-id="element-294">
                <span className="text-[#666666] text-[16px] line-through mb-0.5" data-id="element-295">
                  157,49€
                </span>
                <div className="flex items-baseline" data-id="element-296">
                  <span className="text-[#C9A84C] text-[28px] md:text-[36px] font-extrabold leading-none" data-id="element-297">
                    23,97
                  </span>
                  <span className="text-[#C9A84C] text-[22px] font-bold ml-1" data-id="element-298">
                    €
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* BOTÓN CTA DINÁMICO */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-4" data-id="element-299">
          <button onClick={handleCtaClick} className="w-full min-h-[56px] bg-[#C9A84C] hover:bg-[#F0D080] text-[#0A1628] font-bold text-[18px] uppercase rounded-[10px] py-[12px] px-[36px] shadow-[0_4px_20px_rgba(201,168,76,0.4)] transition-colors font-body" data-id="element-300">
            {selectedPack === 1 ? '→ QUIERO EL MEGAPACK 1' : '→ QUIERO EL SISTEMA COMPLETO'}
          </button>

          {/* BADGES DE CONFIANZA */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-[10px] mt-3 text-[#AAAAAA] text-[13px] font-body" data-id="element-301">
            <span data-id="element-302">🔒 Pago 100% seguro</span>
            <span className="hidden md:inline" data-id="element-303"></span>
            <span data-id="element-304">⚡ Acceso en 5 minutos</span>
            <span className="hidden md:inline" data-id="element-305"></span>
            <span data-id="element-306">🛡️ Garantía 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}